<template>
  <el-dialog title="提示" :visible.sync="visible" custom-class="dialog-center" width="320px" append-to-body>
    <div class="category-tip-modal">
      <span>您当前的审查试用次数仅支持审查【买卖合同】，若需审查其他类别的合同请购买正式次数或升级套餐，谢谢！</span>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="orderModalShow = true">购买次数</el-button>
      <el-button type="primary" @click="routeToProduct">升级/续费套餐</el-button>
    </span>

    <productOrder
      v-if="orderModalShow"
      :show.sync="orderModalShow"
      :productInfo="productInfo"
      showLimit
      @success="paySuccess"
    />
  </el-dialog>
</template>

<script>
import productOrder from '@/components/productOrder';

export default {
  components: { productOrder },
  data() {
    return {
      orderModalShow: false
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    productInfo: {
      type: Object,
      required: true
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    }
  },
  methods: {
    paySuccess() {
      this.$emit('buySuccess');
      this.visible = false;
    },
    routeToProduct() {
      this.$router.push('/product');
    }
  }
};
</script>

<style lang="scss" scoped>
.category-tip-modal {
  font-size: 14px;
  line-height: 20px;
  color: #172237;
}
</style>
